import { RecognitionLogsItemModel } from "../../app/data/documents/models";

export default interface RecognitionLogsState {
  requestStarted: boolean;
  requestSucceed: boolean;
  requestFailed: boolean;
  requestError: string;
  requestCreator: string;
  records: RecognitionLogsItemModel[];
}

export const initialRecognitionLogsState: RecognitionLogsState = {
  requestStarted: false,
  requestSucceed: false,
  requestFailed: false,
  requestError: "",
  requestCreator: "",
  records: []
};
